import * as React from 'react';
import { useSelector } from 'react-redux';
import { openMobileSitePage } from 'shared/map-search/utils/url/openMobileSitePage';

import { trackFiltersClick } from './analytics';
import * as styles from './styles.css';
import { FiltersButton } from '../../../components/Navigation/buttons';
import { selectFiltersUrl } from '../../../selectors/urls';

export const FiltersButtonContainer: React.FC = () => {
  const url = useSelector(selectFiltersUrl);

  const handleClick = React.useCallback((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();

    trackFiltersClick();
    openMobileSitePage(event.currentTarget.href);
  }, []);

  return (
    <div className={styles['filters']}>
      <FiltersButton url={url} onClick={handleClick} size="L" />
    </div>
  );
};
